import { MouseEvent } from 'react';

import { Button } from '../../../cdl/Button/Button';
import { Modal } from '../../../cdl/Modal/Modal';
import { Text } from '../../../cdl/Text/Text';
import { translate } from '../../../common/helpers/translate.helper';
import { Box } from '../../../common/ui/Box';

interface ArchiveAgentConfirmPopupProps {
    isOpen: boolean;
    onSubmit: () => void;
    onDismiss: () => void;
    name: string;
}

export const ArchiveAgentConfirmPopup = ({ isOpen, onSubmit, onDismiss, name }: ArchiveAgentConfirmPopupProps) => {
    const onSubmitButton = (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        onSubmit();
    };

    return (
        <Modal isOpen={isOpen} onDismiss={onDismiss} scrollable={false}>
            <Box padding={24}>
                <Text variant="title" as="h2" marginBottom={8}>
                    {translate('agents.archiveButton.headline')}
                </Text>

                <Text variant="body" as="p">
                    {translate('agents.archiveButton.text')}
                </Text>

                <Text variant="body" as="p" marginTop={24}>
                    {name}
                </Text>
            </Box>
            <Box display="flex" justifyContent="end" paddingX={24} paddingBottom={24}>
                <Button emphasis="high" destructive onClick={onSubmitButton}>
                    {translate('archivePopupButton.submit')}
                </Button>
            </Box>
        </Modal>
    );
};
